import React from "react";
import Navbar from "./components/Navbar";
import Home from "./components/FamilyBoard/Home";
import Calendar from "./components/FamilyBoard/Calendar";
import ShoppingList from "./components/FamilyBoard/ShoppingList";
import MealPlanner from "./components/FamilyBoard/MealPlanner";
import Projects from "./components/FamilyBoard/Projects";
import Docs from "./components/FamilyBoard/Docs";
import FinanceDashboard from "./components/Financial Tracking/FinanceDashboard";
import LoginGate from "./components/Auth/LoginGate";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

class ErrorBoundary extends React.Component {
  state = { error: null };
  static getDerivedStateFromError(e) { return { error: e }; }
  render() {
    if (this.state.error) return (
      <div style={{ padding: 40, color: "#E24B4A", fontFamily: "monospace", fontSize: 13 }}>
        <strong>Something went wrong:</strong>
        <pre style={{ marginTop: 12, color: "#aaa", whiteSpace: "pre-wrap" }}>{this.state.error.message}</pre>
      </div>
    );
    return this.props.children;
  }
}

function App() {
  return (
    <LoginGate>
      <Router>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<ErrorBoundary><Home /></ErrorBoundary>} />
          <Route path="/calendar" element={<ErrorBoundary><Calendar /></ErrorBoundary>} />
          <Route path="/shopping" element={<ErrorBoundary><ShoppingList /></ErrorBoundary>} />
          <Route path="/meals" element={<ErrorBoundary><MealPlanner /></ErrorBoundary>} />
          <Route path="/projects" element={<ErrorBoundary><Projects /></ErrorBoundary>} />
          <Route path="/docs" element={<ErrorBoundary><Docs /></ErrorBoundary>} />
          <Route path="/finance" element={<ErrorBoundary><LoginGate pinOnly><FinanceDashboard /></LoginGate></ErrorBoundary>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </LoginGate>
  );
}

export default App;
